/* unplugin-vue-components disabled */import script from "./Kjjlzx.vue?vue&type=script&lang=ts&setup=true"
export * from "./Kjjlzx.vue?vue&type=script&lang=ts&setup=true"

import "./Kjjlzx.vue?vue&type=style&index=0&id=133fa68c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133fa68c"]])

export default __exports__